import { AreaComponent, NavService, PageBaseComponent } from '@aeins/core';
import { Component, inject } from '@angular/core';
import { IonContent } from '@ionic/angular';

@Component({
    imports: [AreaComponent, IonContent],
    selector: 'aeins-page',
    template: `
        <ion-content [forceOverscroll]="false">
            <a1-area class="flex h-full flex-col" [page]="page" [area]="page.areas.content" (error)="handleError($event)"></a1-area>
        </ion-content>
    `,
    styles: [
        `
            :host.bg-transparent:not(.animating) ion-content {
                --background: transparent;
            }
        `,
    ],
})
export class PageComponent extends PageBaseComponent {
    private readonly _navService = inject(NavService);

    handleError(e: ErrorEvent) {
        this._navService.back();
        console.error(e);
    }
}
